import { Extension } from '@tiptap/core';

/** Keep in sync with `col { width: … }` for TABLE/RECORD in `content-styles.ts`. */
export const CUSTOM_SECTION_TABLE_DEFAULT_COLUMN_WIDTH_PX = 240;

/**
 * TABLE / RECORD custom-section tables: default column width and horizontal scroll are applied
 * via CSS on `.custom-section-content.TABLE` and `.custom-section-content.RECORD`.
 */
export const CustomSectionTableLayoutExtension = Extension.create({
  name: 'customSectionTableLayout',
});
